// @flow
import * as React from 'react';

import styles from '../styles/Typography.scss';

export class Label extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.label}>
        {this.props.children}
      </span>
    );
  }
}

export class PrimaryText extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.primaryText}>
        {this.props.children}
      </span>
    );
  }
}

export class SecondaryText extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.secondaryText}>
        {this.props.children}
      </span>
    );
  }
}

export class HeaderText extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <div className={styles.headerText}>
        {this.props.children}
      </div>
    );
  }
}

export class Error extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.error}>
        {this.props.children}
      </span>
    );
  }
}

export class Warning extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.warning}>
        {this.props.children}
      </span>
    );
  }
}

export class Success extends React.Component<{children?: React.Node}> {
  render() {
    return (
      <span className={styles.success}>
        {this.props.children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./client/src/components/Typography.jsx